import { Button, Form, Card } from "antd";
import React, { FC, useEffect, useState } from "react";
import { CirclePicker } from "react-color";

import styles from "./user-settings.css";
import { HexColour, isDefaultTheme } from "../../themes";
import { UserSettingsType } from "../../data-types";
import { useCurrentUserData } from "../../../hooks";
import { useAuth } from "../../../hooks/use-auth";
import { PermissionToDescription } from "../../../hooks/use-auth/permission";
import { VPDLabel } from "~/context/taxonomy-context";

const {
  ["submit-button"]: submitButton,
  ["default-button"]: defaultButton,
  ["card"]: cardClassName,
} = styles as any;

export type UserSettingsProps = {
  data: UserSettingsType;
  onFinish: (values: any, customPaletteHex: HexColour) => void;
  resetTheme: () => void;
  handleColourSelect: (color: string) => void;
  loading: boolean;
};

export const UserSettings: FC<UserSettingsProps> = ({
  data,
  onFinish,
  handleColourSelect,
  resetTheme,
  loading,
}) => {
  const { currentUser: userData } = useCurrentUserData({ cache: false });
  const { currentUser } = useAuth();
  const permissions =
    currentUser?.permissions
      .map((permission) => {
        return PermissionToDescription.get(permission) || null;
      })
      .filter((x) => x !== null) ?? [];
  const permissionsString = `${permissions.join(", ")}.`;
  console.log(permissions);
  const [customPaletteHex, setCustomPaletteHex] = useState<HexColour>(data?.customPaletteHex);
  const handleReset = () => {
    setCustomPaletteHex(null);
    resetTheme();
  };

  const FEL_LABEL = VPDLabel("FeeEarnerLevel");

  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(data);
  }, [form, data]);

  return (
    <>
      <Card title="User information" className={cardClassName}>
        {userData?.displayName && (
          <p>
            <b>Name:</b> {userData?.displayName}
          </p>
        )}
        {userData?.feeEarnerLevelDescription && (
          <p>
            <b>{FEL_LABEL}:</b> {userData?.feeEarnerLevelDescription}
          </p>
        )}
        {userData?.practiceAreaName && (
          <p>
            <b>Practice Area:</b> {userData?.practiceAreaName}
          </p>
        )}
        {permissionsString && (
          <p>
            <b>Permissions:</b> {permissionsString}
          </p>
        )}
      </Card>
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 15, offset: 1 }}
        onFinish={(values) => onFinish(values, customPaletteHex)}
      >
        <Form.Item name="customPaletteHex" label="Colour palette">
          <CirclePicker
            color={customPaletteHex ?? undefined}
            onChangeComplete={(color) => {
              setCustomPaletteHex(color.hex as HexColour);
              handleColourSelect(color.hex);
            }}
          />
          <Button
            disabled={isDefaultTheme(customPaletteHex)}
            className={defaultButton}
            size="small"
            type="default"
            onClick={handleReset}
          >
            Restore default
          </Button>
        </Form.Item>
        {/* <Form.Item name="darkTheme" label="Dark Mode" valuePropName="checked">
          {!isDefaultTheme(customPaletteHex) ? (
            <Tooltip
              placement="bottomRight"
              title="Dark mode is only accessible when the default colour palette is selected."
              arrowPointAtCenter
            >
              <Switch disabled={true} />
            </Tooltip>
          ) : (
            <Switch />
          )}
        </Form.Item> */}
        <Form.Item>
          <Button loading={loading} className={submitButton} type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};
